import Empty from "@/toremove/components/Empty.vue";
import http from "@/api";

const state = {
    endpoints: {
        company: '/api/company/',
        search: '/api/company/search/',
        addresses: '/api/addresses/',
        email: 'api/user/exist/email/',
        phone: 'api/user/exist/phone/',
    },
    images: {
    //    meetings: '/static/img/PICTO-REUNION-SMALL.svg',
    //    captz: '/static/img/OCTOLO-CAPITAL.svg',
        dataroom: '/static/img/OCTOLO-DATAROOM.svg',
    //    lock: '/static/img/PICTO-VERROU-XS.svg',
    //    folder: '/static/img/PICTO-FOLDEROPEN-ZS.svg',
    //    search: '/static/img/PICTO-SEARCH-SMALL.svg',
    },
    sidebar: {
        isopen: true,
    },
    contextmenu: {
    //    id: 'context-menu',
        isopen: false,
        x: '',
        y: '',
        contain: Empty,
        props: {},
    },
    tooltip: {
        isopen: false,
        data: '',
        yOffset: 25,
        xOffset: 0,
    },
    flyModalIndex: 550,
    crumbs: [],
}

const mutations = {
    // Breadcrumb
    ['SET_CRUMBS'](state, crumbs){
        state.crumbs = crumbs;
    },

    // Sidebar
    ['OPEN_SIDEBAR'](state){
        state.sidebar.isopen = !state.sidebar.isopen;
    },
    ['CLOSE_SIDEBAR'](state){
        state.sidebar.isopen = false;
    },
    ['INC_FLYMODAL'](state){
        state.flyModalIndex++;
    },
    // Context menu
    ['OPEN_CONTEXTMENU'](state, payload){
        state.contextmenu.isopen = true;
        state.contextmenu.x = payload.x;
        state.contextmenu.y = payload.y;
        state.contextmenu.contain = payload.contain;
        if ('props' in payload) {
            Object.assign(state.contextmenu.props, payload.props);
        }
    },
    ['CLOSE_CONTEXTMENU'](state) {
        state.contextmenu =  {
        //    id: 'context-menu',
            isopen: false,
            x: '',
            y: '',
            contain: Empty,
            props: {},
        }
    },
    // Tooltip
    ['OPEN_TOOLTIP'](state, payload){
        state.tooltip.isopen = true;
        state.tooltip.data = payload.data;
        const rect = payload.evt.target.getBoundingClientRect();
        state.tooltip.x = rect.right - ((rect.right - rect.left) / 2);
        state.tooltip.y = rect.top;
        if (payload.yOffset != undefined)
        {
            state.tooltip.y += payload.yOffset;
        }
        if (payload.xOffset != undefined)
        {
            state.tooltip.x += payload.xOffset;
        }
        // state.tooltip.yOffset = payload.yOffset ? payload.yOffset : 0;
        // state.tooltip.xOffset = payload.xOffset ? payload.xOffset : 0;
    },
    ['CLOSE_TOOLTIP'](state){
        state.tooltip =  {
            isopen: false,
            x: '',
            y: '',
            data: '',
            yOffset: 25,
            xOffset: 0,
        }
    },
}

const getters = {
    getTooltipData: (state) => {
        return state.tooltip.data;
    },
    getTooltipStatus: (state) => {
        return state.tooltip.isopen;
    },
}

const actions = {
    // Modal
    //openModalURL(modal){
    //    var urlParams = new URLSearchParams(window.location);
    //    urlParams.append("modals", modal);
    //    //console.log(router.currentRoute.query);
    //    //var modals = router.currentRoute.query.modals;
    //    //if(modals){
    //    //    modals = modals.split(',');
    //    //    if(!modals.includes(modal)) modals.push(modal);
    //    //    router.push({query: {modals: modals.join(',')}});
    //    //}else{
    //    //    router.push({query: {modals: modal}});
    //    //}
    //},
    //closeModalURL(modal){
    //    var modals = router.currentRoute.query.modals;
    //    if(modals){
    //        modals = modals.split(',');
    //        var modal = modals.indexOf(this.modal);
    //        if(modal > -1) delete modals[modal];
    //        modals = modals.join(',');
    //    }
    //    if(modals){
    //        var query = Object.assign({modals: modals}, router.currentRoute.query);
    //        router.replace({ query });
    //    }else{
    //        var query = Object.assign({}, router.currentRoute.query);
    //        delete query.modals;
    //        router.replace({ query });
    //    }
    //},


    // Api Global
    async addresses({ state }, payload){
        const response = await http.get(state.endpoints.addresses, payload);
        return response;
    },
    async addRequestContact({ state }, payload){
        const response = await http.post(state.endpoints.requestcontact, payload)
        .catch(function (error) {
            if (error.response) {
              // Request made and server responded
              return error.response;
            }
            // else if (error.request) {
              // The request was made but no response was received
            // } else {
              // Something happened in setting up the request that triggered an Error
            // }
        });
        return response;
    },
    // Breadcrumb
    setCrumbs({ commit }, crumbs){
        commit('SET_CRUMBS', crumbs != undefined ? crumbs : []);
    },

    // Sidebar
    openSidebar({ commit }){
        commit('OPEN_SIDEBAR');
    },
    closeSidebar({ commit }){
        commit('CLOSE_SIDEBAR');
    },
    incFlyModal({ commit }){
        commit('INC_FLYMODAL');
    },
   // ContextMenu
    openContextMenu({ commit }, payload){
        if('contain' in payload)
            commit('OPEN_CONTEXTMENU', payload);
    },
    closeContextMenu({ commit }) {
        commit('CLOSE_CONTEXTMENU');
    },

   // Tooltip
    openTooltip({ commit, state }, payload){
        if (state.tooltip.data == payload.data) {
            return ;
        }
        commit('CLOSE_TOOLTIP');
        commit('OPEN_TOOLTIP', payload);
    },
    closeTooltip({ commit, state }) {
        if (state.tooltip.isopen)
            commit('CLOSE_TOOLTIP');
    },
}

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
}
